import { useEffect, useState } from "react";
import Sidebar from "../components/Sidebar";
import Navbar from "../components/Navbar";
import API from "../api";
import { useNavigate } from "react-router-dom";

export default function ExploreLeads() {
  const [leads, setLeads] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    API.get("/leads/explore").then(res => setLeads(res.data));
  }, []);

  const apply = async (id) => {
    await API.post(`/leads/${id}/apply`, {
      message: "Interested",
      type: "apply"
    });
    alert("Applied Successfully");
  };

  return (
    <div className="flex">
      <Sidebar />

      <div className="flex-1 bg-gray-50 min-h-screen">
        <Navbar />

        <div className="p-6 space-y-6">

          <h1 className="text-2xl font-bold">Explore Leads</h1>

          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">

            {leads.map(l => (
              <div
                key={l._id}
                className="bg-white p-5 rounded-xl shadow hover:shadow-lg transition"
              >
                {/* HEADER */}
                <h3 className="text-lg font-semibold">{l.title}</h3>

                <p className="text-sm text-gray-500 mt-1">
                  {l.sector} · {l.stage || "Stage"}
                </p>

                {/* HIGHLIGHT */}
                <p className="text-sm mt-2 text-green-600 font-medium">
                  CO₂: {l.co2Reduction || "N/A"}
                </p>

                {/* QUICK INFO */}
                <div className="mt-3 text-sm text-gray-600 space-y-1">
                  <p><b>Interest:</b> {l.companyInfo?.interest || "-"}</p>
                  <p><b>Funding:</b> {l.projectInfo?.fundingSource || "-"}</p>
                </div>

                {/* STATUS */}
                <div className="mt-3">
                  <span className={`text-xs px-2 py-1 rounded ${
                    l.status === "open"
                      ? "bg-green-100 text-green-700"
                      : "bg-red-100 text-red-600"
                  }`}>
                    {l.status}
                  </span>
                </div>

                {/* ACTIONS */}
                <div className="mt-4 flex gap-2">
                  <button
                    onClick={() => navigate(`/lead/${l._id}`)}
                    className="flex-1 border rounded py-2 text-sm hover:bg-gray-100"
                  >
                    View
                  </button>

                  <button
                    onClick={() => apply(l._id)}
                    className="flex-1 bg-green-600 text-white rounded py-2 text-sm hover:bg-green-700"
                  >
                    Apply
                  </button>
                </div>
              </div>
            ))}

          </div>
        </div>
      </div>
    </div>
  );
}